export default __webpack_public_path__ + "imovie.97b0d7e8.png";